module.exports = __webpack_public_path__ + "img/iso.b3fc90fc.png";